import React, { useState, useEffect } from "react";
import style from "./index.module.scss";
import ListItem from "./components/ListItem";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import { QuestionListItem, saveBigQuestionSort } from "service/exercise";
import { message } from "antd";

interface TopicListProps {
    data: QuestionListItem[];
    checked?: number;
    exerciseId: string;
    onChange: (val: number) => void;
    handleOrder: () => void;
}

export default function TopicList({
    data,
    checked,
    exerciseId,
    onChange,
    handleOrder
}: TopicListProps) {
    const [topics, setTopics] = useState<QuestionListItem[]>(data);

    useEffect(() => {
        setTopics(data);
    }, [data]);

    const SortableList = SortableContainer(
        ({ list }: { list: QuestionListItem[] }) => {
            return (
                <div>
                    {list.map((value, index) => (
                        <SortableItem
                            key={`item-${value.id}`}
                            selected={value.id === checked}
                            data={value}
                            id={index}
                            index={index}
                            onSelected={() => onChange(value.id)}
                        />
                    ))}
                </div>
            );
        }
    );

    const SortableItem = SortableElement(
        ({
            selected,
            id,
            data,
            onSelected
        }: {
            selected: boolean;
            id: number;
            data: QuestionListItem;
            onSelected: () => void;
        }) => {
            return (
                <ListItem
                    index={id}
                    data={data}
                    selected={selected}
                    handleClick={onSelected}
                />
            );
        }
    );

    const handleSortType = ({
        oldIndex,
        newIndex
    }: {
        oldIndex: number;
        newIndex: number;
    }) => {
        if (oldIndex === newIndex) return;
        const array = arrayMove(topics, oldIndex, newIndex);
        setTopics(array);
        const questionsId = array.map(item => item.id).join(",");
        saveBigQuestionSort(exerciseId, questionsId)
            .then(res => handleOrder())
            .catch(err => message.error("试题顺序调整失败!"));
    };

    return (
        <div className={style.root}>
            <SortableList
                distance={1}
                list={topics}
                onSortEnd={handleSortType}
                useDragHandle
                lockAxis="y"
            />
        </div>
    );
}
